import { render, staticRenderFns } from "./ProductImageContainer.vue?vue&type=template&id=4c1b2fb8&scoped=true"
import script from "./ProductImageContainer.vue?vue&type=script&lang=js"
export * from "./ProductImageContainer.vue?vue&type=script&lang=js"
import style0 from "./ProductImageContainer.vue?vue&type=style&index=0&id=4c1b2fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1b2fb8",
  null
  
)

export default component.exports